// extracted by mini-css-extract-plugin
module.exports = {"Desc":"TeamRoles_Desc__2RVUw"};